import { Button, IconButton, TextField } from "@mui/material";
import React, { Fragment, Component } from "react";
import userService from "../../services/userService";
import RocketLaunchIcon from "@mui/icons-material/RocketLaunch";
import postService from "../../services/postService";
import LoadingButton from "@mui/lab/LoadingButton";
import FieldLengthLabel from "../commons/FieldLengthLabel";
import { withSnackbar } from "./../../hocs/withSnackbar";

const textFieldStyles = {
  InputProps: {
    style: {
      fontFamily: "inherit",
    },
  },
  InputLabelProps: {
    style: {
      fontFamily: "inherit",
    },
  },
};

class NewReply extends Component {
  state = {
    reply: "",
    newReplyLoading: false,
    hasStartedWriting: false,
  };

  startLoading() {
    this.setState({
      newReplyLoading: true,
    });
  }

  finishLoading() {
    this.setState({
      newReplyLoading: false,
    });
  }

  postNewReply = async () => {
    this.startLoading();
    const { postId, onNewReply } = this.props;
    const { reply } = this.state;
    try {
      const response = await postService.newReply(postId, reply);
      this.finishLoading();
      this.revert();
      onNewReply();
    } catch (error) {
      this.finishLoading();
      this.props.showMessage(error.response.data.message, "error")
    }
  };

  revert() {
    this.setState({
      reply: "",
      hasStartedWriting: false,
    });
  }

  render() {
    const { reply, newReplyLoading, hasStartedWriting } = this.state;
    const currentUser = userService.getCurrentUser();
    const backendApiPath = process.env.REACT_APP_BACKEND_API_PATH;
    const replyMaxLen = process.env.REACT_APP_REPLY_MAXLEN;
    return (
      <Fragment>
        <div
          className="new-reply"
          style={{
            display: "flex",
            alignItems: "center",
            padding: "10px 20px",
            borderBottom: "1px solid #f9f9f9",
          }}
        >
          <div className="post-profile-pic" style={{ marginRight: 20 }}>
            <div className="pic-container" style={{ margin: 0 }}>
              <img
                src={`${backendApiPath}/profile/${currentUser.sub}/pic`}
                height="40"
                width="40"
              />
            </div>
          </div>
          <div
            style={{
              flex: 1,
            }}
          >
            <TextField
              variant="standard"
              label="Your reply"
              fullWidth
              value={reply}
              onChange={(e) => this.setState({ reply: e.target.value })}
              onFocus={() => this.setState({ hasStartedWriting: true })}
              inputProps={{
                maxLength: replyMaxLen,
              }}
              {...textFieldStyles}
            />
            {hasStartedWriting && (
              <FieldLengthLabel length={reply.length} maxLength={replyMaxLen} />
            )}
          </div>
          {hasStartedWriting && (
            <LoadingButton
              style={{
                backgroundColor: "var(--theme-orange)",
                fontFamily: "inherit",
                marginLeft: 20,
                width: 100,
              }}
              fullWidth
              variant="contained"
              loading={newReplyLoading}
              loadingPosition="end"
              endIcon={<RocketLaunchIcon />}
              disabled={reply.trim().length == 0}
              onClick={this.postNewReply}
            >
              reply
            </LoadingButton>
          )}
        </div>
      </Fragment>
    );
  }
}
export default withSnackbar(NewReply);
